/**
 * Fórmulas de Dashboard!C6:C17 que replica kpis.ts (leídas del libro el 13/10/2026).
 * Si la hoja cambia una de estas fórmulas, el KPI se marca "fórmula modificada" y, sin filtros,
 * el sitio muestra el valor de la hoja (fuente de verdad).
 */
import type { KpiId } from '../schema';

export const KPI_FORMULAS: Record<KpiId, string> = {
  onTimeDelivery: `=IFERROR(COUNTIF('OT-01'!$Q$5:$Q$204,"Sí")/(COUNTIF('OT-01'!$Q$5:$Q$204,"Sí")+COUNTIF('OT-01'!$Q$5:$Q$204,"No")),"")`,
  firstPassYield: `=IFERROR(COUNTIFS('OT-01'!$S$5:$S$204,"Sí",'OT-01'!$R$5:$R$204,"Sí")/COUNTIF('OT-01'!$R$5:$R$204,"Sí"),"")`,
  productionEfficiency: `=IFERROR(SUM('OT-01'!$O$5:$O$204)/SUM('OT-01'!$N$5:$N$204),"")`,
  materialsDeviation: `=SUM('COS-01'!$F$5:$F$204)`,
  reworkRatio: `=IFERROR(SUMIFS('PRD-01'!$G$5:$G$204,'PRD-01'!$H$5:$H$204,"Sí")/SUM('PRD-01'!$G$5:$G$204),"")`,
  documentTraceability: `=IFERROR(COUNTIFS('OT-01'!$K$5:$K$204,"Entregado",'OT-01'!$T$5:$T$204,"Sí")/COUNTIF('OT-01'!$K$5:$K$204,"Entregado"),"")`,
  releasesWithPendingTests: `=COUNTIFS('DES-01'!$M$5:$M$204,"<>",'DES-01'!$D$5:$D$204,"No")`,
  safetyIncidents: `=COUNTIF('SEG-01'!$C$5:$C$204,"Incidente")`,
  openUnsafeConditions: `=COUNTIFS('SEG-01'!$C$5:$C$204,"Condición insegura",'SEG-01'!$N$5:$N$204,"Abierta")`,
  unfitInstruments: `=COUNTIF('INS-01'!$M$5:$M$204,"Vencido")+COUNTIF('INS-01'!$M$5:$M$204,"No usar")+COUNTIF('INS-01'!$M$5:$M$204,"Sin calibración verificable")`,
  openNcr: `=COUNTIF('NCR-01'!$N$5:$N$204,"Abierta")+COUNTIF('NCR-01'!$N$5:$N$204,"En corrección")`,
  profitMargin: `=IFERROR(SUM('COS-01'!$O$5:$O$204)/SUM('COS-01'!$C$5:$C$204),"")`,
};

/** Formato de presentación del valor (según el formato de celda del Dashboard). */
export const KPI_FORMAT: Record<KpiId, 'percent' | 'money' | 'int'> = {
  onTimeDelivery: 'percent',
  firstPassYield: 'percent',
  productionEfficiency: 'percent',
  materialsDeviation: 'money',
  reworkRatio: 'percent',
  documentTraceability: 'percent',
  releasesWithPendingTests: 'int',
  safetyIncidents: 'int',
  openUnsafeConditions: 'int',
  unfitInstruments: 'int',
  openNcr: 'int',
  profitMargin: 'percent',
};

/** KPIs que no dependen del filtro por tablero. */
export const GLOBAL_KPIS: readonly KpiId[] = ['safetyIncidents', 'openUnsafeConditions', 'unfitInstruments'];

export function normalizeSheetFormula(f: string | null | undefined): string {
  if (!f) return '';
  let out = '';
  let inStr = false;
  for (const ch of f) {
    if (ch === '"') inStr = !inStr;
    if (!inStr && /\s/.test(ch)) continue;
    out += inStr ? ch : ch.toUpperCase();
  }
  return out.replace(/'/g, '');
}
